import { Editor, DowncastAttributeEvent, ViewElement } from "ckeditor5";

import { TableStyleDefinition } from "./utils";

export const createConversions = (
  editor: Editor,
  definitions: Record<string, TableStyleDefinition>,
) => {
  for (const def of Object.values(definitions)) {
    //
    // Just register an upcast for each set of classes, this is simpler than
    // having a single upcast which needs to look at the classes and match them
    // back to the definitions
    //
    editor.conversion.for("upcast").attributeToAttribute({
      view: {
        name: "table",
        classes: def.classes,
      },
      model: {
        name: "table",
        key: "tableClass",
        value: def.name,
      },
    });
  }

  editor.conversion.for("downcast").add((d) =>
    //
    // We have to do a manual downcast to put the classes on the <table> element
    // instead of on the outer <figure> element
    //
    d.on<DowncastAttributeEvent>(
      "attribute:tableClass",
      (
        _e,
        { item, attributeKey, attributeOldValue, attributeNewValue },
        { writer, mapper, consumable },
      ) => {
        consumable.consume(item, `attribute${attributeKey}`);

        if (!item.is("element")) return;
        const viewElement = mapper.toViewElement(item);
        if (!viewElement?.is("element")) return;
        const tableElement = Array.from(viewElement.getChildren()).find(
          (e): e is ViewElement => e.is("element") && e.name === "table",
        );
        if (tableElement == null) return;

        if (attributeOldValue != null) {
          writer.removeClass(
            definitions[attributeOldValue as string]?.classes,
            tableElement,
          );
        }

        if (attributeNewValue) {
          writer.addClass(
            definitions[attributeNewValue as string]?.classes,
            tableElement,
          );
        }
      },
    ),
  );
};
